import React from 'react';
import { About } from '../components/sections/About';
import { CoreValues } from '../components/sections/CoreValues';
import { FrenchExperience } from '../components/sections/FrenchExperience';
import { Leadership } from '../components/sections/Leadership';

export const AboutPage = () => {
  return (
    <div className="pt-24 md:pt-32 bg-ivory">
      <About />
      <CoreValues />
      <FrenchExperience />
      <Leadership />
    </div>
  );
};